import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import { COLORS, FONT } from "../shared/styles";
import { NOTIFICATION_EVENTS } from "./constants";
import PreferenceCheckbox from "./PreferenceCheckbox";

const tableGridSx = {
  display: "grid",
  gridTemplateColumns: "minmax(0, 1fr) 72px 72px 72px",
  alignItems: "center",
  columnGap: "8px",
};

function NotificationSettingsTable({
  preferences,
  onToggle,
  events = NOTIFICATION_EVENTS,
  loading = false,
}) {
  return (
    <>
      <Typography
        component="h3"
        sx={{
          mt: "32px",
          mb: 0,
          color: COLORS.textPrimary,
          fontFamily: FONT.family,
          fontSize: "20px",
          fontWeight: 500,
          lineHeight: "34px",
        }}
      >
        Notification Settings
      </Typography>

      <Box sx={{ mt: "16px", width: "100%" }}>
        <Box sx={{ ...tableGridSx, pb: "12px", borderBottom: `1px solid ${COLORS.borderLight}` }}>
          <Typography
            component="span"
            sx={{
              color: COLORS.textSecondary,
              fontFamily: FONT.family,
              fontSize: "12px",
              fontWeight: 500,
              lineHeight: "18px",
            }}
          >
            Event
          </Typography>
          {["In-App", "Browser", "Email"].map((label) => (
            <Typography
              key={label}
              component="span"
              sx={{
                textAlign: "center",
                color: COLORS.textSecondary,
                fontFamily: FONT.family,
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "18px",
              }}
            >
              {label}
            </Typography>
          ))}
        </Box>

        {events.map((event) => {
          const row = preferences[event.key] || event.defaults;
          return (
            <Box
              key={event.key}
              sx={{
                ...tableGridSx,
                py: "16px",
                borderBottom: "1px solid #F0F2F4",
                "&:last-child": {
                  borderBottom: "none",
                },
              }}
            >
              <Box>
                <Typography
                  component="p"
                  sx={{
                    m: 0,
                    color: COLORS.textPrimary,
                    fontFamily: FONT.family,
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "18px",
                  }}
                >
                  {event.title}
                </Typography>
                <Typography
                  component="p"
                  sx={{
                    mt: "4px",
                    mb: 0,
                    color: COLORS.textSecondary,
                    fontFamily: FONT.family,
                    fontSize: "12px",
                    fontWeight: 400,
                    lineHeight: "18px",
                  }}
                >
                  {event.description}
                </Typography>
              </Box>
              {(["inApp", "browser", "email"]).map((channel) => (
                <Box key={channel} sx={{ display: "flex", justifyContent: "center" }}>
                  {loading ? (
                    <Skeleton
                      variant="rounded"
                      width={24}
                      height={24}
                      sx={{ borderRadius: "4px" }}
                    />
                  ) : (
                    <PreferenceCheckbox
                      checked={!!row[channel]}
                      onChange={() => onToggle(event.key, channel)}
                      label={`${event.title} ${channel}`}
                    />
                  )}
                </Box>
              ))}
            </Box>
          );
        })}
      </Box>
    </>
  );
}

export default NotificationSettingsTable;
